//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.8.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------

export enum UserRole {
    User = 0,
    Admin = 1,
    SuperAdmin = 100,
}

export interface UserRightsResult {
    importVersionEnabled: boolean | undefined;
    exportVersionEnabled: boolean | undefined;
    dashboardEnabled: boolean | undefined;
    translationsReviewEnabled: boolean | undefined;
    featuresReviewEnabled: boolean | undefined;
    configuratorEnabled: boolean | undefined;
    userManagementEnabled: boolean | undefined;
    allowedPlatforms: string[] | undefined;
    publicationConfiguratorEnabled: boolean | undefined;
    userRole: UserRole | undefined;
    logsExplorerEnabled: boolean | undefined;
    isAdmin: boolean;
    statusChangeEnabledLevel: number;
}
